import { useMutation } from '@tanstack/react-query';

import type { UpdateInsurerAccessesParams } from '../../../Domain/Owners/Services/OwnerService/ownerService';
import { ownerService } from '../../../Domain/Owners/Services/OwnerService/ownerService';

const mutationFn = (data: UpdateInsurerAccessesParams) => {
  return ownerService.updateInsurerAccesses(data);
};

export const useOwnerUpdateInsurerAccessesMutation = () => {
  return useMutation<unknown, unknown, UpdateInsurerAccessesParams>(mutationFn);
};
